
import ChangeStoreSideMenu from 'JS/components/side-menus/change-store/ChangeStoreSideMenu.vue';
import Icon from 'JS/components/Icon.vue';
import LinkButton from 'JS/components/LinkButton.vue';
import TransitionExpand from 'JS/components/transitions/TransitionExpand.vue';
import UiButton from 'JS/components/UiButton.vue';
import { computed, defineComponent, ref } from 'vue';
import { ILocalStoreJson } from 'JS/types/LocalStore';
import { PropType } from 'vue';;

export default defineComponent({
	name: 'AutomotiveServiceCenterStoreInfo',
	components: {
		TransitionExpand,
		UiButton,
		LinkButton,
		ChangeStoreSideMenu,
		Icon,
	},
	props: {
		store: { type: Object as PropType<ILocalStoreJson> },
		hideDirections: { type: Boolean, required: false },
		variant: {
			type: String as PropType<'simple' | 'no-directions' | 'full'>,
			default: 'full',
		},
	},
	setup(props) {
		return {
			showHours: ref(false),
			showChangeStore: ref(false),
			hours: computed(() => Object.entries(props.store?.autoHours ?? {})),
			isOpen: computed(() => props.store?.autoIsOpen),
			// NOTE: we need the place id and the address to ensure the stores can be found as expected on android maps.
			storeLink: computed(() => !!props.store
				? `https://www.google.com/maps/search/?api=1&query_place_id=${props.store.googlePlaceID}&query=${encodeURIComponent(props.store.address1)},${encodeURIComponent(props.store.city)},${props.store.state}`
				: null),
		};
	}
});
